/** Number / latency / percentage formatting helpers. */

const COMPACT = new Intl.NumberFormat("en-NZ", {
  notation: "compact",
  maximumFractionDigits: 1,
});
const STANDARD = new Intl.NumberFormat("en-NZ");

/** 12,345 → "12,345"; 12,345,678 → "12.3M". */
export function fmtNumber(n: number | null | undefined, opts?: { compact?: boolean }): string {
  if (n == null || !Number.isFinite(n)) return "—";
  if (opts?.compact && Math.abs(n) >= 10_000) return COMPACT.format(n);
  return STANDARD.format(Math.round(n));
}

export function fmtPct(n: number | null | undefined, fractionDigits = 1): string {
  if (n == null || !Number.isFinite(n)) return "—";
  return `${n.toFixed(fractionDigits)}%`;
}

export function fmtSignedPct(n: number | null | undefined, fractionDigits = 1): string {
  if (n == null || !Number.isFinite(n)) return "—";
  const sign = n > 0 ? "+" : n < 0 ? "−" : "";
  return `${sign}${Math.abs(n).toFixed(fractionDigits)}%`;
}

export function fmtLatency(ms: number | null | undefined): string {
  if (ms == null || !Number.isFinite(ms)) return "—";
  if (ms < 1) return "<1 ms";
  if (ms < 1000) return `${Math.round(ms)} ms`;
  return `${(ms / 1000).toFixed(2)} s`;
}

export function truncateMiddle(s: string, max = 32): string {
  if (s.length <= max) return s;
  const head = Math.ceil(max / 2) - 1;
  const tail = Math.floor(max / 2) - 2;
  return `${s.slice(0, head)}…${s.slice(-tail)}`;
}
